import React from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { Users, Eye } from "lucide-react";
import { createPageUrl } from "@/shared/utils";
import { Badge } from "@/shared/components/ui/badge";
import { Button } from "@/shared/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/shared/components/ui/table";

export default function ResellersTab({ resellers, statusConfig, t }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("resellersCreatedByThisEngine")} ({resellers.length})</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table className="min-w-[760px]">
            <TableHeader>
              <TableRow>
                <TableHead>{t("reseller")}</TableHead>
                <TableHead>{t("code")}</TableHead>
                <TableHead>{t("status")}</TableHead>
                <TableHead>{t("merchants")}</TableHead>
                <TableHead>{t("created")}</TableHead>
                <TableHead></TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {resellers.map(reseller => (
                <TableRow key={reseller.id} className="cursor-pointer hover:bg-slate-50">
                  <TableCell>
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center">
                        <Users className="h-4 w-4 text-purple-600" />
                      </div>
                      <div>
                        <p className="font-medium">{reseller.name}</p>
                        <p className="text-sm text-slate-500">{reseller.email}</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge variant="outline">{reseller.code}</Badge>
                  </TableCell>
                  <TableCell>
                    <Badge className={statusConfig[reseller.status?.toLowerCase()]?.color || "bg-slate-100"}>
                      {t((reseller.status || "").toLowerCase())}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    {reseller.merchantCount ?? 0} / {reseller.maxMerchants || 10}
                  </TableCell>
                  <TableCell className="text-slate-500">
                    {reseller.createdAt ? format(new Date(reseller.createdAt), "MMM d, yyyy") : t("nA")}
                  </TableCell>
                  <TableCell>
                    <Link to={createPageUrl("AdminResellerDetail") + `?id=${reseller.id}`}>
                      <Button variant="ghost" size="icon"><Eye className="h-4 w-4" /></Button>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
